import _ from "lodash";
/**
 * 获取待处理地址列表
 */
export const waitDealLocation = {
  methods: {
    /**
     * 获取地址列表
     */
    waitDealLocation() {
      this.$request(
        "post",
        "/waitDealLocation/getTreeList",
        { flag: true },
        (data) => {
          data.forEach((item) => {
            item.children.forEach((ele) => {
              ele.children = "";
            });
          });
          this.list = data;
          this.isAdd = false;
        },
        (errormessage) => {
          this.$message.error(errormessage);
        },
      );
    },
  },
};

/**
 * 好销云呼叫
 */
export const callNumber = {
  methods: {
    /**
     * 好销云呼叫
     */
    callNumber: _.throttle(function (phone) {
      let requestData = {
        TelB: phone, // 被叫号码号码
        userId: this.baseInfo.userId, // 操作人
      };
      console.log("requestData", requestData);
      let flag1 = this.$phoneCheck.mobilePhoneNumberCheck(requestData.TelB); // 校验
      if (!flag1) {
        this.$message.error("手机号格式不正确,请确认填入正确的手机号!");
        return;
      }
      this.$request(
        "post",
        "/haoXiaoYun/bind",
        requestData,
        (data2) => {
          this.$message.success("绑定成功, 请耐心等待呼叫!");
        },
        (errormessage2) => {
          this.$message.error(errormessage2);
        },
      );
    }, 2000),
  },
};

/**
 * 获取客户列表
 */
export const getClientByQuery = {
  methods: {
    getClientByQuery(data) {
      data.item.loading = true;
      this.$request(
        "get",
        "/client/searchOptions?companyId=" +
          this.baseInfo.company.companyId +
          "&keyword=" +
          data.query,
        {},
        (responseData) => {
          data.item.options = responseData.map((it) => {
            return {
              label: it.clientName,
              value: it.id,
            };
          });
          data.item.loading = false;
        },
        (errorMessage) => {
          data.item.loading = false;
          this.$message.error(errorMessage);
        },
      );
    },
  },
};

/**
 * 延迟调用
 * @param {*} fns 函数数组
 * @param {*} delay 延迟时间
 * @returns
 */
export const callWithDelay = {
  methods: {
    callWithDelay(fns, delay) {
      fns.reduce((prev, fn, index) => {
        return prev.then(() => {
          return new Promise((resolve) => {
            setTimeout(
              () => {
                fn();
                resolve();
              },
              index === 0 ? 0 : delay,
            );
          });
        });
      }, Promise.resolve());
    },
  },
};

/**
 * 延迟调用
 * @param {*} fns 函数数组
 * @param {*} delay 延迟时间
 * @returns
 */
export const cleanEmptyChildren = {
  methods: {
    /**
     * 递归删除树形数据中空的 children 字段
     * 解决 el-cascader 无法正确识别叶子节点的问题
     * @param data 树形数据数组
     * @return 处理后的数据
     * @author lcj
     * @date 2026-06-23
     */
    cleanEmptyChildren(data) {
      if (!Array.isArray(data)) return data;
      return data.map((item) => {
        const newItem = { ...item };
        if (
          newItem.children &&
          Array.isArray(newItem.children) &&
          newItem.children.length > 0
        ) {
          newItem.children = this.cleanEmptyChildren(newItem.children);
        } else {
          delete newItem.children;
        }
        return newItem;
      });
    },
  },
};

/**
 * 根据文件路径获取文件类型
 * @param {*} url 文件路径
 * @returns 文件类型
 */
export const fileType = {
  methods: {
    fileType(url) {
      if (url) {
        const extension = url.substr(url.lastIndexOf(".") + 1).toLowerCase();
        if (extension === "png" || extension === "jpg") return "img";
        if (extension === "pdf") return "pdf";
        if (extension === "xlsx" || extension === "xls") return "excel";
        if (extension === "doc" || extension === "docx") return "word";
        if (extension === "mp4" || extension === "avi") return "video";
        if (extension === "mp3" || extension === "mp2" || extension === "wav")
          return "audio";
      } else {
        return "";
      }
    },
  },
};
